// extracted by mini-css-extract-plugin
export default {"delete_button":"Item_delete_button__C5n5J"};